import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";
import stores from "cd-eft/models/Stores";
import { action } from "mobx";

const { terraceDesignStore } = stores.AppStore;

export class ProfileSettingsContainerVM {
    private profileSettingsForm;
    private parentType: 'Waterway' | 'Three Cross Sections' | 'Terrace' | 'UGO'
    private formValidation: any;

    constructor(parentType, formValidation, profileSettingsForm) {
        this.parentType = parentType;
        this.formValidation = formValidation;
        this.profileSettingsForm = profileSettingsForm;
    }

    @action.bound async handleSettingInputChange(event, button?) {
        const { target } = event;
        const id = target.id ? target.id : 'fineGrid';
        if (this.parentType === 'Terrace') terraceDesignStore.terraceInputsChanged = true;
        
        let value;
        if (button === 'plus') {
          value = Math.trunc((Number(this.profileSettingsForm.input.fineGrid) + 1));
        } else if (button === 'minus') {
          value = Math.trunc((Number(this.profileSettingsForm.input.fineGrid) - 1));
        } else {
          value = target.value
        }
        this.profileSettingsForm.input[id] = value;
        await this.validateField(id, value);
      }

    async validateField(fieldName, value: number) {
        const keyValid = fieldName + 'Valid';
        let fieldValid;
        if (this.parentType === "Three Cross Sections") {
            fieldValid = (fieldName === "fineGrid" && value > 0) || (fieldName === 'bufferWidth' && value >= 0);
        } else {
            fieldValid = value > 0;
        }
        const fieldValidationErrors = this.formValidation.formErrors;
        let errorCode: string = '';

        fieldValidationErrors[fieldName] = fieldValid ? '' : '  ';
        errorCode = fieldValid ? '' : 'Common_10';

        this.formValidation.formErrors = fieldValidationErrors;
        this.formValidation[keyValid] = fieldValid;
        await this.validateForm(errorCode);
    }

    // checks if there are any error msgs over entire form
    @action.bound async validateForm(errorCode) {
        let valid = true;
        for (const key in this.formValidation.formErrors) {
            if (!this.formValidation[key + 'Valid']) {
                valid = false;
            }
        }
        this.formValidation.formValid = valid;
        if (!valid) {
            if (!MessageCenter.currentMessage) {
                await MessageCenter.addNotificationFromCode(errorCode, undefined, 'Profile setting values');
            }
        } else {
            MessageCenter.clearMessages();
        }

    }
}